var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReferenceToolsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M31 4.24h-2V3.07a1 1 0 0 0-1-1h-2a21.37 21.37 0 0 0-10 2.05 16.83 16.83 0 0 0-4.69-1.6 1.017 1.017 0 1 0-.37 2A14.79 14.79 0 0 1 15 5.85v18.48a33.17 33.17 0 0 0-9.95-1.62V4.07h2.17a1 1 0 1 0 0-2H4.05a1 1 0 0 0-1 1v1.17H1a1 1 0 0 0-1 1v21.52a1 1 0 0 0 .3.71c.193.18.446.283.71.29.1 0 10.67-.07 14.51 2a1 1 0 0 0 1 0c3.84-2.11 13.53-2 13.64-2H31a1 1 0 0 0 1-1V5.24a1 1 0 0 0-1-1zm-4-.17v18.64a33.17 33.17 0 0 0-10 1.62V5.85a19.61 19.61 0 0 1 9-1.78h1zm3 21.69c-1.21 0-9.72 0-14 2-3.78-1.75-11.27-2-14-2V6.24h1V23.7a1 1 0 0 0 .3.72 1 1 0 0 0 .72.28c.07 0 7.54-.08 11.45 2.05h.14a.86.86 0 0 0 .68 0h.14c3.91-2.13 11.37-2.05 11.45-2.05a1 1 0 0 0 1-1V6.24H30v19.52z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReferenceToolsLight);
export default __webpack_public_path__ + "static/media/icon-reference-tools-light.03c1b9844d0f801b5efc8340cace7ede.svg";
export { ForwardRef as ReactComponent };